// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CUIvy","title":"styles_title__fr9Nv","event":"styles_event__Vmp+D","button":"styles_button__tHkhk"};